import type * as Types from 'app/types/graphql';

import { ShopPlatformRevenueSelectFragmentDoc } from '../fragments/shopPlatformPlan.generated';
import { UsageFeeCurrentSelectFragmentDoc } from '../fragments/usageFeeCurrent.generated';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type UsageFeeCurrentQueryVariables = Types.Exact<{
  shopPlatformID: Types.Scalars['ID']['input'];
}>;

export type UsageFeeCurrentQueryResponse = {
  usageFeeCurrent?: Types.Maybe<
    Pick<
      Types.UsageFeeCurrent,
      'currencyCode' | 'cycleEndDate' | 'cycleStartDate' | 'price' | 'tierID' | 'usageAmount'
    > & { revenue?: Types.Maybe<Pick<Types.ShopPlatformRevenue, 'id' | 'date' | 'totalRevenue'>> }
  >;
};

export const UsageFeeCurrentDocument = `
    query UsageFeeCurrent($shopPlatformID: ID!) {
  usageFeeCurrent(shopPlatformID: $shopPlatformID) {
    ...UsageFeeCurrentSelect
  }
}
    ${UsageFeeCurrentSelectFragmentDoc}
${ShopPlatformRevenueSelectFragmentDoc}`;

export const useUsageFeeCurrentQuery = <TData = UsageFeeCurrentQueryResponse, TError = unknown>(
  variables: UsageFeeCurrentQueryVariables,
  options?: UseQueryOptions<UsageFeeCurrentQueryResponse, TError, TData>,
) => {
  return useQuery<UsageFeeCurrentQueryResponse, TError, TData>(
    ['UsageFeeCurrent', variables],
    appFetcher<UsageFeeCurrentQueryResponse, UsageFeeCurrentQueryVariables>(
      UsageFeeCurrentDocument,
      variables,
    ),
    options,
  );
};

useUsageFeeCurrentQuery.getKey = (variables: UsageFeeCurrentQueryVariables) => [
  'UsageFeeCurrent',
  variables,
];
